"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ofType = exports.ofID = exports.of = exports["default"] = void 0;

var activities = function activities(_ref) {
  var activities = _ref.activities;
  return activities;
};

var of = function of(predicate) {
  return function (state) {
    return activities(state).filter(predicate);
  };
};

exports.of = of;

var ofID = function ofID(targetID) {
  return of(function (_ref2) {
    var id = _ref2.id;
    return id === targetID;
  });
};

exports.ofID = ofID;

var ofType = function ofType(targetType) {
  return of(function (_ref3) {
    var type = _ref3.type;
    return type === targetType;
  });
};

exports.ofType = ofType;
var _default = activities;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJhY3Rpdml0aWVzIiwib2YiLCJwcmVkaWNhdGUiLCJzdGF0ZSIsImZpbHRlciIsIm9mSUQiLCJ0YXJnZXRJRCIsImlkIiwib2ZUeXBlIiwidGFyZ2V0VHlwZSIsInR5cGUiXSwic291cmNlUm9vdCI6ImNvcmU6Ly8vIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VsZWN0b3JzL2FjdGl2aXRpZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBSZWR1eFN0YXRlIH0gZnJvbSAnLi4vdHlwZXMvaW50ZXJuYWwvUmVkdXhTdGF0ZSc7XG5pbXBvcnQgdHlwZSB7IFdlYkNoYXRBY3Rpdml0eSB9IGZyb20gJy4uL3R5cGVzL1dlYkNoYXRBY3Rpdml0eSc7XG5cbmNvbnN0IGFjdGl2aXRpZXMgPSAoeyBhY3Rpdml0aWVzIH06IFJlZHV4U3RhdGUpID0+IGFjdGl2aXRpZXM7XG5cbmNvbnN0IG9mID0gKHByZWRpY2F0ZTogKGFjdGl2aXR5OiBXZWJDaGF0QWN0aXZpdHkpID0+IGJvb2xlYW4pID0+IChzdGF0ZTogUmVkdXhTdGF0ZSkgPT5cbiAgYWN0aXZpdGllcyhzdGF0ZSkuZmlsdGVyKHByZWRpY2F0ZSk7XG5jb25zdCBvZklEID0gKHRhcmdldElEOiBzdHJpbmcpID0+IG9mKCh7IGlkIH0pID0+IGlkID09PSB0YXJnZXRJRCk7XG5jb25zdCBvZlR5cGUgPSAodGFyZ2V0VHlwZTogc3RyaW5nKSA9PiBvZigoeyB0eXBlIH0pID0+IHR5cGUgPT09IHRhcmdldFR5cGUpO1xuXG5leHBvcnQgZGVmYXVsdCBhY3Rpdml0aWVzO1xuZXhwb3J0IHsgb2YsIG9mSUQsIG9mVHlwZSB9O1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBR0EsSUFBTUEsVUFBVSxHQUFHO0VBQUEsSUFBR0EsVUFBSCxRQUFHQSxVQUFIO0VBQUEsT0FBZ0NBLFVBQWhDO0FBQUEsQ0FBbkI7O0FBRUEsSUFBTUMsRUFBRSxHQUFHLFNBQUxBLEVBQUssQ0FBQ0MsU0FBRDtFQUFBLE9BQXVELFVBQUNDLEtBQUQ7SUFBQSxPQUNoRUgsVUFBVSxDQUFDRyxLQUFELENBQVYsQ0FBa0JDLE1BQWxCLENBQXlCRixTQUF6QixDQURnRTtFQUFBLENBQXZEO0FBQUEsQ0FBWDs7OztBQUVBLElBQU1HLElBQUksR0FBRyxTQUFQQSxJQUFPLENBQUNDLFFBQUQ7RUFBQSxPQUFzQkwsRUFBRSxDQUFDO0lBQUEsSUFBR00sRUFBSCxTQUFHQSxFQUFIO0lBQUEsT0FBWUEsRUFBRSxLQUFLRCxRQUFuQjtFQUFBLENBQUQsQ0FBeEI7QUFBQSxDQUFiOzs7O0FBQ0EsSUFBTUUsTUFBTSxHQUFHLFNBQVRBLE1BQVMsQ0FBQ0MsVUFBRDtFQUFBLE9BQXdCUixFQUFFLENBQUM7SUFBQSxJQUFHUyxJQUFILFNBQUdBLElBQUg7SUFBQSxPQUFjQSxJQUFJLEtBQUtELFVBQXZCO0VBQUEsQ0FBRCxDQUExQjtBQUFBLENBQWY7OztlQUVlVCxVIn0=